export default function callParkingReducer(callParking, action) {
  switch (action.type) {
    case "set":
      return action.value;

    case "exten":
      return { ...callParking, exten: action.value ? Number(action.value).toString() : "" };
    case "returnCallAfterTimeout":
      return { ...callParking, [action.type]: action.value, timeoutOverflow: null };

    case "checkParkingRange":
      return {
        ...callParking,
        rangeStart: (Number(callParking.exten) + 1).toString(),
        rangeEnd: (Number(callParking.exten) + 5).toString(),
      };

    default:
      return { ...callParking, [action.type]: action.value };
  }
}
